<template>
  <!--<div class="headbar" :class="usname==''?'white':'black'">-->
  <div class="headbar" :class="fcstyle">
    <div class="conter cbox head-ptop">
      <div class="logo fl">
        <h1>· 佳洪电子 ·</h1>
      </div>
      <div class="nav fr">
        <div class="dtl">
          <router-link
            to="/bankacceptance/Control"
            v-if="usname != ''"
            class="usinto"
            >
            <h1>用户名：{{ usname }}</h1>
            </router-link>
          <span
            v-if="usname != ''"
            title="退出"
            alt="退出"
            class="usexit iconfont"
            @click="userexit"
            >退出</span
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    fcstyle: {
      type: String,
      default: "black",
    },
  },
  data() {
    return {
      usname: this.$store.state.user,
    };
  },
  mounted: function () {},
  methods: {
    userexit() {
      this.usname = "";
      this.$store.commit("del_token", this.uscode);
      this.$router.push({ name: "Loginlink" });
      this.$router.go(0);
    }
  }
};
</script>
<style>
.headbar {
  width: 100%;
  height: 30px;
  padding: 30px 0;
  position: relative;
  background: url("../assets/headerbg.jpg") no-repeat;
  background-size: 110% 350%;
  background-position-x: 40%;
}
.placement {
  padding-top: 20px;
}
.logo {
  width: 110px;
  height: 110px;
  background: url("../assets/headerlogo.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: absolute;
  top: 50%;
  transform: translate(0,-50%);
}
.logo h1{
  font-size: 20px;
  font-weight: 700;
  position: absolute;
  top: 50%;
  left: -3px;
  transform: translate(0,-50%);
}
.nav {
  float: right;
  width: 600px;
  height: 20px;
  padding-top: 5px;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
}
.nav a {
  display: block;
  height: 20px;
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 20px;
  margin: 0 20px;
  text-align: center;
  float: left;
  position: relative;
}
.nav a:hover {
  color: #207fb7;
}
.white {
  color: #fff;
}
.black {
  color: #333;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3;
  box-shadow: 0px 5px 9px 0px rgba(204, 204, 204, 0.3);
}
.nav a.usinto {
  margin: 0 0 0 20px;
}
.usexit {
  font-size: 20px;
  font-weight: 600;
  display: block;
  float: right;
  cursor: pointer;
  width: 50px;
  height: 20px;
  text-align: right;
  overflow: hidden;
}
.usexit:hover {
  width: 60px;
  transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
}
/* .usexit::before {
  content: "\e622";
  color: #fff;
  float: right;
  margin-right: 10px;
  margin-top: 2px;
} */
.usexit,
.usexit:hover {
  transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
}
.hei .usexit,
.hei .usexit::before {
  color: #555;
}
@media only screen and (max-width: 600px) {
  .central {
    width: 100%;
    display: table;
  }
  .headbar {
    width: 50%;
    height: 100%;
    height: 100vh;
    background: #fff;
    z-index: 99;
    display: table;
  }
  .placement {
    padding: 0;
  }
  .logo {
    clear: both;
    display: table;
    margin: 15%;
    width: 2.36rem;
    height: 0.51rem;
    background-size: 100%;
  }
  .nav,
  .nav a,
  .usexit {
    width: 100%;
    display: table;
    clear: both;
  }
  .nav a,
  .usexit {
    height: 1rem;
    line-height: 1rem;
    font-size: 0.32rem;
    color: #333;
    text-align: center;
    margin: 0;
  }
  .nav a.thenow:after {
    display: none;
  }
  .nav a.usinto {
    margin: 0;
    clear: both;
    display: table;
  }
  /* .usexit:before {
    content: "\E622";
    color: #333;
    margin-right: 10px;
    margin-top: 10px;
  } */
}
.dtl {
  min-width: 280px;
  display: table;
  float: right;
}
.dtl h1{
  font-size: 20px;
  font-weight: 600;
}
</style>





// WEBPACK FOOTER //
// src/components/headbar.vue